import React from 'react';

const PagenotFound = () => {
    return (
        <div>
            <h2>Sorry, Page not found, 404</h2>
        </div>
    );
};

export default PagenotFound;